import merge from 'deepmerge';
import {updatePropertyPreferences} from 'api/propertyPreferences';

const UPDATE = 'pulp/sellersReservePrice/UPDATE';

export const initialState = {
  reservePrice: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return merge(state, action.payload);
    default:
      return state;
  }
}

export function updateSellersReservePrice(payload, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {
        propertyDetail: {propertyId},
        sellersReservePrice,
      } = getState();
      updatePropertyPreferences(propertyId, {sellersReservePrice: merge(sellersReservePrice, payload)});
    }

    dispatch({
      type: UPDATE,
      payload,
    });
  };
}
